
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/file-input/file-input-list.component.js'
      import type { DdsFileClickEvent } from '../../events/events'
      export type { DdsFileClickEvent } from '../../events/events'

      const tagName = 'dap-ds-file-input-list'

      /**
 * `dap-ds-file-input-list`
 * @summary A file input list is a container for file input items.
 * @element dap-ds-file-input-list
 * @title - File input list
 * @group file-input
 *
 * @slot delete-button - The delete button.
 *
 * @event {{ file: FileListElement }} dds-file-click - Dispatched when a file is clicked.
 *
 * @csspart base - The main file input list container.
 *
 * @cssproperty --dds-file-list-display - Controls the display property (default: flex)
 * @cssproperty --dds-file-list-flex-direction - Controls the flex-direction property (default: column)
 * @cssproperty --dds-file-list-padding - Controls the padding property (default: 0)
 * @cssproperty --dds-file-list-list-style - Controls the list-style-type property (default: none)
 * @cssproperty --dds-file-list-gap - Controls the row-gap property (default: var(--dds-spacing-200))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsFileClick: 'dds-file-click' as EventName<DdsFileClickEvent>
        },
        displayName: "DapDSFileInputList"
      })

      export default reactWrapper
    